import * as React       from 'react';
import Box              from '@mui/material/Box';
import Avatar           from '@mui/material/Avatar';
import Menu             from '@mui/material/Menu';
import MenuItem         from '@mui/material/MenuItem';
import ListItemIcon     from '@mui/material/ListItemIcon';
import Divider          from '@mui/material/Divider';
import IconButton       from '@mui/material/IconButton';
//import {useTheme}       from '@mui/material';
import Logout           from '@mui/icons-material/Logout';
import Home             from '@mui/icons-material/Home';
//import Brightness4Icon  from '@mui/icons-material/Brightness4';
//import Brightness7Icon  from '@mui/icons-material/Brightness7';
//import ColorModeContext from 'style/Theme';
import { useNavigate }  from 'react-router-dom';
import { useAuth }      from 'auth/AuthProvider';
import {
    MENU_HOME,
    //MENU_DARK_MODE,
    //MENU_LIGHT_MODE,
    MENU_LOGOUT,
    MENU_PROFILE
}                       from 'config/config';
import { 
    ReactComponent as AccountIcon
}                       from 'icons/account.svg';

export default function AccountMenu() {
    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);
    const auth = useAuth();
    //const theme = useTheme();
    //const colorMode = React.useContext(ColorModeContext);
    const navigate = useNavigate();
    const handleClick = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };
    return (
        <React.Fragment>
            <Box sx={{ display: 'flex', alignItems: 'center', textAlign: 'center' }}>
                <IconButton onClick={handleClick} size="small" >
                    <Avatar sx={{ width: 32, height: 32 }}>
                        <AccountIcon/>
                    </Avatar>
                </IconButton>
            </Box>
            <Menu
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                onClick={handleClose}
                PaperProps={{
                    elevation: 0,
                    sx: {
                        overflow: 'visible',
                        filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
                        mt: 1.5,
                        '& .MuiAvatar-root': {
                            width: 32,
                            height: 32,
                            ml: -0.5,
                            mr: 1,
                        },
                        '&:before': {
                            content: '""',
                            display: 'block',
                            position: 'absolute',
                            top: 0,
                            right: 14,
                            width: 10,
                            height: 10,
                            bgcolor: 'background.paper',
                            transform: 'translateY(-50%) rotate(45deg)',
                            zIndex: 0,
                        },
                    },
                }}
                transformOrigin={{ horizontal: 'right', vertical: 'top' }}
                anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
            >
                <MenuItem onClick={() => {navigate('/profile')}}>
                    <Avatar sx={{visibility: 'hidden'}} />
                    {MENU_PROFILE}
                </MenuItem>
                <Divider />
                <MenuItem onClick={() => {navigate('/')}}>
                    <ListItemIcon>
                        <Home fontSize="small" />
                    </ListItemIcon>
                    {MENU_HOME}
                </MenuItem>
                <MenuItem onClick={() => {
                    auth.signout().then(() => {navigate('/signin')});
                }}>
                    <ListItemIcon>
                        <Logout fontSize="small"/>
                    </ListItemIcon>
                    {MENU_LOGOUT}
                </MenuItem>
                {/*<Divider/>
                <MenuItem onClick={()=>colorMode.toggleColorMode()}>
                    <ListItemIcon>
                        {theme.palette.mode === 'dark' ?
                            <Brightness7Icon /> :
                            <Brightness4Icon />
                        }
                    </ListItemIcon>
                    {theme.palette.mode === 'dark' ?
                        MENU_LIGHT_MODE :
                        MENU_DARK_MODE
                    }
                </MenuItem>*/}
            </Menu>
        </React.Fragment>
    );
}